module.exports = __webpack_public_path__ + "static/media/download.c41e08cf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fiduciaria_flow_5/img/download.png
 ** module id = 1431
 ** module chunks = 0
 **/